import { render } from "./MainNav.vue?vue&type=template&id=b2c408e8&scoped=true"
const script = {}

import "./MainNav.vue?vue&type=style&index=0&id=b2c408e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c408e8"]])

export default __exports__